import { render, staticRenderFns } from "./MoleculeContentEditor.vue?vue&type=template&id=2b9434dc&"
import script from "./MoleculeContentEditor.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports